<div class="tooltip-content">
  <div class="line"></div>
  <p style="display: flex;">This is a subscriber’s feature, click to see a sample of what you are missing out on!</p>
</div>
